




import {Component, Ref, Vue} from "vue-property-decorator";
import OriginatorRules from "@/pages/Pages/Rules/OriginatorRules.vue";
import {MsgTransports} from "@/store/types";

@Component({components: {OriginatorRules}})
export default class SmsOriginatorRules extends Vue {
  private smsTransport: MsgTransports = MsgTransports.SMS
}
